/* eslint-disable sort-keys-fix/sort-keys-fix */
import { TinyColor } from "@ctrl/tinycolor";
import { Colors } from "../colors";
import darkEmptyStateSvg from "../../public/images/DarkModeEmptyState.svg";
export const defaultDarkTheme2023 = (userTheme) => {
    var _a;
    const defaultText = Colors.lightGray[200];
    const warningText = Colors.auvikYellow[900];
    const errorText = Colors.auvikRed[800];
    const successText = Colors.auvikGreen[900];
    const infoText = Colors.auvikCyan[900];
    return {
        svg: {
            emptyStateSvg: darkEmptyStateSvg,
        },
        colors: {
            background: Colors.black,
            mainText: defaultText,
            // In the Dark Theme case `linkColor` is possibly `undefined`
            linkColor: (_a = userTheme.darkThemeAction) !== null && _a !== void 0 ? _a : "",
            linkHoverColor: userTheme.darkThemeAction
                ? new TinyColor(userTheme.darkThemeAction).lighten(10).toString()
                : undefined,
            headerText: userTheme.darkThemeBrandSecondary,
            secondardHeaderText: userTheme.darkThemeBrandSecondary,
            auvik: Object.assign({}, Colors),
            // Accordion
            accordionColors: {
                accordionBackground: Colors.eggplantGray[900],
                accordionBorder: Colors.eggplantGray[300],
                accordionHeader: Colors.eggplantGray[800],
                accordionTitle: Colors.eggplantGray[200],
                successIcon: Colors.auvikGreen[500],
                pendingIcon: Colors.auvikRed[500],
                blockedIcon: Colors.gray[500],
                defaultIcon: Colors.auvikPurple[500],
            },
            // Alert Box
            alertBoxColors: {
                errorBackground: Colors.auvikRed[50],
                errorBorder: Colors.auvikRed[100],
                errorText,
                infoBackground: Colors.auvikSkyBlue[50],
                infoBorder: Colors.auvikLavender[100],
                infoText,
                successBackground: Colors.auvikGreen[50],
                successBorder: Colors.auvikGreen[100],
                successText,
                warningBackground: Colors.auvikYellow[50],
                warningBorder: Colors.auvikOrange[50],
                warningText,
            },
            // Card
            cardColors: {
                cardBackground: Colors.eggplantGray[800],
                cardBorder: Colors.lavenderGray[800],
                cardIcon: userTheme.darkThemeBrandSecondary,
            },
            // Chart
            chartColors: {
                axisLabels: defaultText,
                colors: [
                    Colors.auvikSkyBlue[900],
                    Colors.auvikCyan[500],
                    Colors.auvikYellow[100],
                    Colors.auvikPink[500],
                    Colors.auvikOrange[100],
                    Colors.auvikGreen[100],
                    Colors.auvikPurple[500],
                    Colors.auvikLime[900],
                    Colors.auvikCyan[800],
                    Colors.auvikPurple[50],
                ],
                defaultBackgroundColor: Colors.eggplantGray[800],
                defaultColor: Colors.auvikPurple[800],
                defaultReferenceArea: Colors.auvikEggplant[100],
                emptyChartText: defaultText,
                legendText: defaultText,
                risk: {
                    alert: Colors.auvikPurple[500],
                    critical: Colors.auvikRed[500],
                    high: Colors.auvikOrange[500],
                    medium: Colors.auvikYellow[500],
                    low: Colors.auvikGreen[500],
                    safe: Colors.auvikCyan[500],
                    default: Colors.auvikEggplant[500],
                },
                riskFill: {
                    critical: Colors.auvikRed[50],
                    high: Colors.auvikOrange[50],
                    medium: Colors.auvikYellow[50],
                    low: Colors.auvikGreen[50],
                    alert: Colors.auvikPurple[50],
                    safe: Colors.auvikCyan[50],
                    default: Colors.auvikEggplant[500],
                },
                riskStroke: {
                    critical: Colors.auvikRed[800],
                    high: Colors.auvikOrange[800],
                    medium: Colors.auvikYellow[800],
                    low: Colors.auvikGreen[800],
                    alert: Colors.auvikPurple[800],
                    safe: Colors.auvikCyan[800],
                    default: Colors.auvikEggplant[500],
                },
                stroke: Colors.lightGray[500],
                toolTipBackground: Colors.eggplantGray[800],
                toolTipBorder: Colors.eggplantGray[600],
                toolTipDefaultColor: Colors.black,
                progressCircleBackground: Colors.gray[800],
            },
            // Checklist
            checklistColors: {
                currentItemCircleBorder: Colors.auvikPurple[500],
                currentItemCircleBackground: userTheme.darkThemeBrandPrimary,
                futureItemCircleBorder: Colors.lavenderGray[500],
                doneItemCheckmark: userTheme.darkThemeBrandPrimary,
                separatorBorder: Colors.auvikPurple[800],
            },
            // Dashboard
            dashboardColors: {
                keyValueValueText: Colors.gray[200],
                keyValueLabelText: defaultText,
                multiKpiEmptyText: defaultText,
                singleKpiValueText: defaultText,
                singleKpiEmptyText: defaultText,
            },
            // Deprecated Search Box
            deprecatedSearchBoxColors: {
                autocompleteHoverBackground: Colors.white,
                autocompleteHoverText: Colors.gray[700],
                autocompleteSelectedBackground: Colors.lightGray[200],
                autocompleteBackground: Colors.lightGray[200],
                autocompleteText: Colors.gray[700],
                listingTitleBackground: Colors.eggplantGray[600],
                listingBackground: Colors.eggplantGray[700],
                wrapperBackground: Colors.eggplantGray[700],
                wrapperBorder: Colors.eggplantGray[700],
            },
            // Drag and Drop:
            dndColors: {
                buttonColor: Colors.white,
                hoverButtonBackgroundColor: Colors.auvikPurple[900],
                hoverCellBackgroundColor: Colors.auvikPurple[800],
            },
            // Expression Builder
            expressionBuilderColors: {
                background: "transparent",
                ruleBackground: Colors.black,
                connectingLines: Colors.auvikPurple[500],
            },
            // List
            listColors: {
                itemBackground: Colors.eggplantGray[800],
                itemText: defaultText,
                itemSelectedText: Colors.lightGray[300],
                itemSelectedBackground: userTheme.darkThemeBrandPrimary,
                itemHoverBackground: `${userTheme.darkThemeAction}26`,
                itemHoverText: defaultText,
                border: Colors.black,
                background: Colors.black,
            },
            // Radio
            radioColors: {
                markBorder: Colors.lavenderGray[500],
                markBackground: Colors.white,
                markHoverBorder: userTheme.darkThemeBrandPrimary,
                inputCheckedBackground: userTheme.darkThemeBrandPrimary,
                disabledBackground: Colors.gray[50],
                disabledBorder: Colors.lavenderGray[500],
                backgroundAfter: Colors.white,
                disabledBackgroundAfter: Colors.gray[500],
                disabledLabel: Colors.lavenderGray[400],
            },
            // Inputs
            inputColors: {
                inputBackground: Colors.eggplantGray[700],
                inputBorder: Colors.eggplantGray[700],
                inputText: defaultText,
                inputPlaceholder: Colors.eggplantGray[200],
                inputDisabledBackground: Colors.eggplantGray[600],
                inputDisabledText: Colors.gray[100],
                inputDisabledBorder: Colors.eggplantGray[700],
                fieldsetDisabledBackground: Colors.eggplantGray[700],
                inputFocusBorder: Colors.auvikSkyBlue[500],
                inputErrorBorder: Colors.auvikRed[500],
                inputErrorText: Colors.auvikPink[500],
                inputSuccessBorder: Colors.auvikGreen[500],
                inputFileInputDisabledBackground: Colors.eggplantGray[700],
                prefixSuffixContainerBackground: Colors.eggplantGray[600],
                prefixSuffixContainerBorder: Colors.eggplantGray[600],
                prefixSuffixContainerDisabledText: Colors.gray[300],
                dropDownBackground: Colors.eggplantGray[700],
                dropDownOptionFocusedBackground: userTheme.darkThemeBrandPrimary,
                dropDownOptionBackground: Colors.eggplantGray[700],
                dropDownOptionText: defaultText,
                dropDownOptionSelected: userTheme.darkThemeBrandPrimary,
                dropDownOptionFocused: defaultText,
                dropDownOptionError: Colors.auvikRed[500],
                dropDownOptionDisabled: Colors.lightGray[500],
                dropDownIndicator: Colors.white,
                dropDownIndicatorHover: Colors.lightGray[300],
                noOptionsText: defaultText,
            },
            // Checkbox
            checkboxColors: {
                checkboxDisabledBackground: Colors.gray[300],
                checkboxDisabledBorder: Colors.lightGray[500],
                checkboxDisabledCheckmark: Colors.gray[100],
                checkboxBackground: Colors.eggplantGray[700],
                checkboxBorder: Colors.black,
                checkboxCheckmark: userTheme.darkThemeBrandPrimary,
                checkboxFocusBorder: Colors.auvikLavender[500],
            },
            // Flyout
            flyoutColors: {
                flyoutBackground: Colors.eggplantGray[800],
                flyoutTitle: defaultText,
                flyoutIcon: defaultText,
                closeIcon: Colors.lightGray[800],
                collapsePanelButtonBackground: userTheme.themeBrandPrimary,
                collapsePanelButtonBackgroundHover: new TinyColor(userTheme.themeBrandPrimary).lighten(20).toString(),
                collpasePanelButtonBorder: userTheme.themeBrandPrimary,
                collapsePanelArrowcolor: Colors.white,
            },
            // Modals
            modalColors: {
                modalBackground: Colors.eggplantGray[800],
                modalHeaderBackground: userTheme.darkThemeBrandSecondary,
                modalHeaderText: Colors.white,
                modalFooter: Colors.eggplantGray[800],
                overlay: "rgba(0,0,0,0.9)",
            },
            // Details Area
            detailsAreaColors: {
                titleIconColor: Colors.white[500],
                background: Colors.black,
                shadowColor: "transparent",
            },
            // FormFieldWrapper
            formFieldWrapperColors: {
                helperText: Colors.gray[300],
                requiredStar: Colors.auvikRed[500],
            },
            // FormInputCopy
            formInputCopyColors: {
                icon: defaultText,
            },
            // FormInputPassword
            formInputPasswordColors: {
                buttonBorder: Colors.eggplantGray[600],
                buttonBackground: Colors.eggplantGray[600],
                buttonText: defaultText,
            },
            // FormPanel
            formPanelColors: {
                headerText: userTheme.darkThemeBrandSecondary,
            },
            // Tabs
            tabsColors: {
                tabsBorders: Colors.eggplantGray[800],
                tabText: Colors.lightGray[800],
                tabHoverText: userTheme.darkThemeBrandPrimary,
                selectedBackground: userTheme.darkThemeBrandPrimary,
                tabBackgroundHover: Colors.eggplantGray[700],
                tabListBackground: Colors.eggplantGray[900],
            },
            // Step
            stepColors: {
                label: Colors.auvikEggplant[300],
                futureLabel: Colors.gray[300],
                completedBorder: Colors.auvikGreen[500],
                completed: Colors.auvikGreen[500],
                currentBorder: Colors.auvikPurple[500],
                current: Colors.auvikEggplant[300],
                future: Colors.gray[300],
                futureBorder: Colors.gray[300],
            },
            // Tooltip
            tooltipColors: {
                darkBackground: Colors.eggplantGray[800],
                darkText: defaultText,
                lightBackground: Colors.white,
                lightText: Colors.gray[700],
                tableBackground: Colors.eggplantGray[800],
                tableText: defaultText,
            },
            // LoadingSpinner
            loadingSpinner: {
                color: userTheme.darkThemeBrandPrimary,
            },
            // Popup
            popupColors: {
                background: Colors.eggplantGray[800],
                border: Colors.eggplantGray[800],
            },
            // ProgressBar
            progressBarColors: {
                background: Colors.lavenderGray[400],
                containerBackground: Colors.auvikLavender[500],
                progress: userTheme.darkThemeBrandPrimary,
                text: defaultText,
            },
            // Toast
            toastColors: {
                red: {
                    background: Colors.auvikRed[50],
                    border: Colors.auvikRed[900],
                    text: errorText,
                },
                blue: {
                    background: Colors.auvikCyan[50],
                    border: Colors.auvikCyan[900],
                    text: Colors.auvikCyan[900],
                },
                green: {
                    background: Colors.auvikGreen[50],
                    border: Colors.auvikGreen[900],
                    text: successText,
                },
                yellow: {
                    background: Colors.auvikYellow[50],
                    border: Colors.auvikYellow[900],
                    text: Colors.auvikBrown[900],
                },
            },
            // Toggle
            toggleColors: {
                checked: userTheme.darkThemeBrandPrimary,
                disabled: Colors.lightGray[800],
                background: Colors.lavenderGray[600],
            },
            // Table
            tableColors: {
                columnPinningBoxShadowColor: Colors.auvikPurple[100],
                paginationActiveBackground: userTheme.darkThemeBrandPrimary,
                paginationActiveText: defaultText,
                paginationHoverText: Colors.gray[500],
                paginationHoverBackground: userTheme.darkThemeBrandPrimary
                    ? new TinyColor(userTheme.darkThemeBrandPrimary).lighten(25).toString()
                    : undefined,
                paginationText: Colors.eggplantGray[500],
                placehoderGradient1: Colors.lavenderGray[300],
                placehoderGradient2: Colors.lightGray[50],
                statusMessageBackground: userTheme.darkThemeBrandPrimary,
                statusMessageText: defaultText,
                tableBackground: Colors.eggplantGray[800],
                tableBorder: Colors.eggplantGray[800],
                tableRowEven: Colors.black,
                tableRowHeader: Colors.black,
                tableRowHeaderCaret: Colors.gray[300],
                tableRowHover: `${userTheme.darkThemeAction}26`, // 15% opacity
                tableRowHoverSolid: Colors.auvikPurple[900],
                tableRowOdd: Colors.eggplantGray[800],
                tableSortedIndicator: userTheme.darkThemeBrandSecondary,
            },
            // Buttons
            invertedButtonColors: {
                invertedButtonBackground: Colors.eggplantGray[800],
                invertedButtonText: Colors.white,
                invertedButtonBorder: Colors.white,
                invertedButtonHoverBackground: userTheme.darkThemeAction
                    ? new TinyColor(userTheme.darkThemeAction).darken(10).toString()
                    : undefined,
                invertedButtonHoverText: Colors.white,
                invertedButtonHoverBorder: userTheme.darkThemeAction
                    ? new TinyColor(userTheme.darkThemeAction).darken(10).toString()
                    : undefined,
                invertedButtonActiveBackground: userTheme.darkThemeAction,
                invertedButtonActiveText: Colors.white,
                invertedButtonActiveBorder: userTheme.darkThemeAction,
                invertedButtonDisabledBackground: Colors.eggplantGray[700],
                invertedButtonDisabledText: Colors.eggplantGray[500],
                invertedButtonDisabledBorder: Colors.eggplantGray[500],
                invertedButtonFocusBackground: userTheme.darkThemeAction,
                invertedButtonFocusText: Colors.white,
                invertedButtonFocusBorder: userTheme.darkThemeAction,
            },
            invertedDarkButtonColors: {
                invertedDarkButtonBackground: "transparent",
                invertedDarkButtonText: Colors.white,
                invertedDarkButtonBorder: "transparent",
                invertedDarkButtonHoverBackground: Colors.auvikLavender[500],
                invertedDarkButtonHoverText: Colors.black,
                invertedDarkButtonHoverBorder: Colors.auvikLavender[500],
                invertedDarkButtonActiveBackground: Colors.auvikLavender[500],
                invertedDarkButtonActiveText: Colors.black,
                invertedDarkButtonActiveBorder: Colors.auvikLavender[500],
                invertedDarkButtonDisabledBackground: Colors.lavenderGray[600],
                invertedDarkButtonDisabledText: Colors.black,
                invertedDarkButtonDisabledBorder: Colors.lavenderGray[600],
                invertedDarkButtonFocusBackground: Colors.auvikLavender[500],
                invertedDarkButtonFocusText: Colors.black,
                invertedDarkButtonFocusBorder: Colors.auvikLavender[500],
            },
            secondaryButtonColors: {
                secondaryButtonDisabledBackground: Colors.lavenderGray[600],
                secondaryButtonFocusBackground: userTheme.darkThemeAction,
                secondaryButtonHoverText: Colors.white,
                secondaryButtonFocusText: Colors.white,
                secondaryButtonText: Colors.white,
                secondaryButtonBackground: "transparent",
                secondaryButtonHoverBackground: userTheme.darkThemeAction
                    ? new TinyColor(userTheme.darkThemeAction).darken(10).toString()
                    : undefined,
                secondaryButtonDisabledText: Colors.black,
                secondaryButtonDisabledBorder: Colors.lavenderGray[600],
                secondaryButtonFocusBorder: userTheme.darkThemeAction,
                secondaryButtonHoverBorder: userTheme.darkThemeAction
                    ? new TinyColor(userTheme.darkThemeAction).darken(10).toString()
                    : undefined,
                secondaryButtonBorder: Colors.white,
            },
            tertiaryButtonColors: {
                tertiaryButtonHoverText: userTheme.darkThemeAction,
                tertiaryButtonFocusText: userTheme.darkThemeAction,
                tertiaryButtonText: userTheme.darkThemeAction,
                tertiaryButtonDisabledText: Colors.lavenderGray[600],
                tertiaryButtonDisabledBorder: Colors.lavenderGray[600],
                tertiaryButtonFocusBorder: userTheme.darkThemeAction,
                tertiaryButtonHoverBorder: userTheme.darkThemeAction,
                tertiaryButtonBorder: userTheme.darkThemeAction,
            },
            primaryButtonColors: {
                disabledBackground: Colors.lavenderGray[600],
                focusBackground: userTheme.darkThemeAction
                    ? new TinyColor(userTheme.darkThemeAction).darken(10).toString()
                    : undefined,
                focusText: Colors.white,
                disabledText: Colors.black,
                hoverBackground: userTheme.darkThemeAction
                    ? new TinyColor(userTheme.darkThemeAction).darken(10).toString()
                    : undefined,
                hoverText: Colors.white,
                background: userTheme.darkThemeAction,
                text: Colors.white,
                default: Colors.lavenderGray[500],
            },
            destructiveButtonColors: {
                disabledBackground: Colors.lavenderGray[600],
                focusBackground: Colors.auvikRed[100],
                focusText: Colors.white,
                disabledText: Colors.black,
                hoverBackground: Colors.auvikRed[100],
                hoverText: Colors.white,
                background: Colors.auvikRed[800],
                text: Colors.white,
                default: Colors.lavenderGray[500],
            },
            iconButtonColors: {
                hoverBorder: userTheme.darkThemeBrandPrimary,
                background: "transparent",
                border: Colors.white,
                disabled: Colors.lavenderGray[600],
                focusBackground: "rgba(0, 0, 0, 0.15)",
            },
            // icons
            iconColors: {
                avatar: Colors.black,
                avatarSecondary: Colors.white,
                avatarTertiary: Colors.white,
                avatarQuaternary: Colors.black,
                button: Colors.auvikLavender[800],
                danger: Colors.auvikRed[500],
                disabled: Colors.eggplantGray[400],
                grey: Colors.lavenderGray[700],
                info: Colors.auvikCyan[800],
                infoDark: Colors.auvikSkyBlue[800],
                primary: Colors.white,
                secondary: Colors.auvikPurple[500],
                sidebar: Colors.white,
                success: Colors.auvikGreen[500],
                tertiary: Colors.auvikLavender[500],
                textColor: Colors.white,
                tooltipQ: Colors.white,
                warningDark: Colors.auvikOrange[500],
                warningLight: Colors.auvikYellow[500],
                white: Colors.white,
            },
            // Text
            textColors: {
                cardHeading: defaultText,
                cardHeadingCount: defaultText,
                critical: Colors.auvikOrange[500],
                default: defaultText,
                detailsArea: defaultText,
                emergency: Colors.auvikRed[500],
                greyIcon: defaultText,
                greyIconHover: userTheme.darkThemeAction,
                greyIconDisabled: Colors.lavenderGray[500],
                greyLink: defaultText,
                greyLinkHover: userTheme.darkThemeAction,
                header: defaultText,
                informational: Colors.auvikCyan[500],
                link: userTheme.darkThemeAction,
                subTitle: defaultText,
                warning: Colors.auvikYellow[500],
                whiteIcon: Colors.lavenderGray[500],
                whiteIconHover: defaultText,
                whiteIconDisabled: Colors.lavenderGray[500],
            },
            // SearchBox
            searchBoxColors: {
                buttonText: defaultText,
                buttonBackground: Colors.eggplantGray[800],
                buttonActiveBackground: userTheme.darkThemeBrandPrimary,
                buttonFocusBackground: userTheme.darkThemeBrandPrimary,
                buttonHoverBackground: userTheme.darkThemeBrandPrimary,
                magnifyingGlass: Colors.lavenderGray[500],
                dismiss: Colors.black,
                dismissActive: Colors.black,
                filterBackground: userTheme.darkThemeBrandPrimary
                    ? new TinyColor(userTheme.darkThemeBrandPrimary).lighten(25).toString()
                    : undefined,
                filterActiveBackground: userTheme.darkThemeBrandPrimary,
                filterBorder: userTheme.darkThemeBrandPrimary,
                filterActiveText: Colors.black,
                filterText: Colors.black,
                filterDisabledBackground: Colors.lavenderGray[50],
                filterDisabledBorder: Colors.lavenderGray[100],
                filterDisabledText: Colors.gray[300],
                dropDownBorder: Colors.eggplantGray[700],
                dropDownBackground: Colors.eggplantGray[700],
                hintBackground: Colors.eggplantGray[700],
                hintText: defaultText,
                facetPillBackground: userTheme.darkThemeBrandPrimary
                    ? new TinyColor(userTheme.darkThemeBrandPrimary).lighten(25).toString()
                    : undefined,
                facetPillBorder: userTheme.darkThemeBrandPrimary,
                facetPillText: Colors.black,
                dropdownSuggestionTitle: defaultText,
                suggestionItemText: defaultText,
                suggestionItemActiveText: defaultText,
                suggestionItemActiveBackground: userTheme.darkThemeBrandPrimary,
                dropdownTitleBackground: Colors.eggplantGray[800],
                dropdownTitleText: defaultText,
                arrow: Colors.eggplantGray[800],
                arrowBorder: Colors.white,
                arrowContainerBorder: Colors.eggplantGray[700],
            },
            // Wizard
            wizardColors: {
                border: Colors.lavenderGray[500],
                stepLabelCurrent: Colors.white,
                stepLabelStyle: defaultText,
                currentStepBorder: Colors.auvikPurple[500],
                currentCircleBorder: userTheme.darkThemeBrandPrimary,
                separatorLine: userTheme.darkThemeBrandPrimary,
                separatorLineCompleted: userTheme.darkThemeBrandPrimary,
                separatorLineCurrent: Colors.lavenderGray[500],
                separatorLinePending: Colors.lavenderGray[500],
                completedBackground: userTheme.darkThemeBrandPrimary,
                currentBackground: Colors.white,
                pendingBackground: Colors.lavenderGray[500],
                footerBackground: Colors.eggplantGray[800],
            },
            // Badge
            badgeColors: {
                alertBackground: Colors.auvikRed[800],
                alertText: Colors.white,
                badgeLabelText: Colors.black,
                chipBackground: userTheme.darkThemeBrandPrimary
                    ? new TinyColor(userTheme.darkThemeBrandPrimary).lighten(25).toString()
                    : undefined,
                closeButton: Colors.gray[300],
                chipBorder: userTheme.darkThemeBrandPrimary,
                chipText: Colors.black,
                criticalBackground: Colors.auvikOrange[500],
                criticalText: Colors.black,
                criticalLightBackground: Colors.auvikOrange[500],
                criticalLightText: Colors.white,
                criticalLightBorder: Colors.auvikOrange[500],
                customBackground: Colors.auvikEggplant[500],
                customText: Colors.white,
                customLightBackground: Colors.eggplantGray[500],
                customLightBorder: Colors.eggplantGray[500],
                customLightText: Colors.white,
                debugBackground: Colors.gray[100],
                debugText: Colors.black,
                defaultBackground: Colors.auvikLavender[500],
                defaultText: Colors.white,
                dryBackground: Colors.auvikPurple[50],
                dryText: Colors.black,
                emergencyBackground: Colors.auvikRed[500],
                emergencyText: Colors.white,
                emergencyLightBackground: Colors.auvikRed[500],
                emergencyLightText: Colors.white,
                emergencyLightBorder: Colors.auvikRed[500],
                errorBackground: Colors.auvikRed[500],
                errorText: Colors.black,
                informationalBackground: Colors.auvikCyan[500],
                informationalText: Colors.black,
                informationalLightBackground: Colors.auvikCyan[500],
                informationalLightBorder: Colors.auvikCyan[500],
                informationalLightText: Colors.black,
                noticeBackground: Colors.auvikCyan[900],
                noticeText: Colors.white,
                primaryBackground: userTheme.darkThemeBrandSecondary,
                primaryText: Colors.black,
                primaryDarkBackground: userTheme.darkThemeBrandPrimary,
                primaryDarkText: Colors.black,
                primaryLightBackground: Colors.auvikLavender[500],
                primaryLightText: Colors.white,
                primaryLightBorder: Colors.auvikLavender[500],
                secondaryBackground: Colors.auvikPink[500],
                secondaryText: Colors.black,
                secondaryLightBackground: Colors.auvikPink[500],
                secondaryLightBorder: Colors.auvikPink[500],
                secondaryLightText: Colors.white,
                successBackground: Colors.auvikGreen[500],
                successText: Colors.black,
                successLightBackground: Colors.auvikGreen[500],
                successLightBorder: Colors.auvikGreen[500],
                successLightText: Colors.white,
                warningBackground: Colors.auvikYellow[500],
                warningText: Colors.black,
                warningLightBackground: Colors.auvikYellow[500],
                warningLightBorder: Colors.auvikYellow[500],
                warningLightText: Colors.black,
            },
        },
    };
};
